import { create } from 'zustand';
import {
  ReverseGeocodeAddress,
  GeocodeCandidate,
  FeatureCollection,
  AddressSuggestion,
} from '@api/services/geospatial/types';
import _cloneDeep from 'lodash/cloneDeep';

interface GeospatialState {
  projectLocationAddress?: ReverseGeocodeAddress | undefined;
  addressSuggestions?: AddressSuggestion[] | [];
  addressCandidates?: GeocodeCandidate[] | [];
  projectGeometryData?: FeatureCollection | null;
  resourceGeometryData?: FeatureCollection | null;
  setProjectLocationAddress: (address: ReverseGeocodeAddress) => void;
  setAddressSuggestions: (suggestions: AddressSuggestion[]) => void;
  setAddressCandidates: (candidates: GeocodeCandidate[]) => void;
  setProjectGeometryData: (geometry: FeatureCollection) => void;
  setResourceGeometryData: (geometry: FeatureCollection) => void;
  clearGeospatialStore: () => void;
}

const defaults = {
  projectLocationAddress: undefined,
  addressSuggestions: [],
  addressCandidates: [],
  projectGeometryData: null,
  resourceGeometryData: null,
};

export const useGeospatial = create<GeospatialState>((set) => ({
  ..._cloneDeep(defaults),
  setProjectLocationAddress: (projectLocationAddress: ReverseGeocodeAddress) => set({ projectLocationAddress }),
  setAddressSuggestions: (addressSuggestions: AddressSuggestion[]) => set({ addressSuggestions }),
  setAddressCandidates: (addressCandidates: GeocodeCandidate[]) => set({ addressCandidates }),
  setProjectGeometryData: (projectGeometryData: FeatureCollection) => set({ projectGeometryData }),
  setResourceGeometryData: (resourceGeometryData: FeatureCollection) => set({ resourceGeometryData }),
  clearGeospatialStore: () => set(_cloneDeep(defaults)),
}));
